export const regionalOverview = {
  defaultYear: "Año predeterminado",
  selectYear: "Seleccione el año para comparar",
  selectedYear: "año seleccionado",
  note: "*Nota: Los datos presentados en estos gráficos representan información que ha sido aprobada por el gobierno.",
};
